import { Timestamp } from '@angular/fire/firestore';
import { Geolocation } from './geolocation.model';

export interface Session {
  id?: string;
  sessionName?: string;
  sessionStatus: SessionStatus;

  lessonId?: string;
  lessonName?: string;

  gradeId?: string;
  gradeName?: string;
  academicYear?: number;

  groupId?: string;

  startDate: Timestamp;
  endDate: Timestamp;
  startTime: Timestamp;
  endTime: Timestamp;

  teacherId?: string;
  teacherName?: string;
  teacherPhotoUrl?: string;

  location?: Geolocation;

  created: Timestamp;
  modified: Timestamp;
}

export enum SessionStatus {
  active = 'active',
  closed = 'closed',
}
